export const memberElectionSelector = (state) => {
    return state.memberElection;
};